import React from 'react';

export function ProgressBar({ currentStep, totalSteps, className = '' }) {
  return (
    <div className={`space-y-3 ${className}`}>
      <p className="text-caption text-muted uppercase tracking-wider">
        Step {currentStep} of {totalSteps}
      </p>
      <div className="flex gap-2">
        {Array.from({ length: totalSteps }).map((_, index) => (
          <div
            key={index}
            className={`
              h-1 flex-1 transition-colors duration-normal
              ${index < currentStep ? 'bg-foreground' : 'bg-border'}
            `}
          />
        ))}
      </div>
    </div>
  );
}

export default ProgressBar;
